import React from "react";
import { Link } from "react-router-dom";

const LastServiceSec = () => {
	return (
		<div className='space-y-12 w-full'>
			{/* First Section: Title and Description (Flex layout) */}
			<div className='max-w-[1440px] w-[90%] mx-auto space-y-6 py-12'>
				<h2 className='text-4xl lg:text-[64px] lg:leading-[76px] leading-[50px] font-semibold text-[#1D1D1D] xl:text-left text-center'>
					How to Access Our Services
				</h2>
				<p className='md:text-2xl/9 text-lg/6 text-[#43474F] font-light mt-4 leading-relaxed lg:w-[80%] w-full mx-auto text-center'>
					If you or someone you know could benefit from these services, visit
					our{" "}
					<Link
						to={"/get-started"}
						className='text-[#08C362] underline decoration-[#08C362] font-medium'>
						Get Started
					</Link>{" "}
					page to complete the Patient Support Survey. Together, we’ll create a
					plan to address your needs and connect you with the appropriate
					resources.
				</p>
			</div>

			{/* Second Section: Title, Description, and Buttons (Flex-col layout) */}
			<div className='bg-[#E4FFF2] py-12 px-6'>
				<div className='max-w-5xl mx-auto flex flex-col items-center space-y-6'>
					{/* Title and Description */}
					<div className='text-center'>
						<h2 className='text-xl md:text-5xl font-semibold text-[#1D1D1D] leading-tight'>
							Join Us in Making a Difference
						</h2>
						<p className='text-lg text-[#11112d] font-normal mt-4 leading-relaxed'>
							Whether you’re a patient, provider, or supporter, SynergyCare
							Foundation is here to transform lives and create equitable access
							to care for everyone.
						</p>
					</div>

					{/* Buttons Section */}
					<div className='flex flex-col sm:flex-row gap-4 w-full justify-center'>
						{/* Link to /donate */}
						<Link
							to='/get-involved'
							className='text-[0A142F] text-base bg-[#22E27F] px-6 py-3 rounded-full sm:w-fit w-full text-center'>
							Get Involved
						</Link>
						{/* Link to /volunteer */}
						<Link
							to='/contact'
							className='text-[#22E27F] text-base px-6 py-3 rounded-full border-[#22E27F] border sm:w-fit w-full  text-center'>
							Contact
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default LastServiceSec;
